module.exports = __webpack_public_path__ + "static/media/me.264e83cf.jpg";